import useApplyMembershipPayment from "@features/payment/lib/hooks/useApplyMembershipPayment";
import { useForm } from "@tanstack/react-form";
import type { ApplyFormValues } from "./types";

const DEFAULT_VALUES: ApplyFormValues = {
  companyName: "",
  firstName: "",
  lastName: "",
  countryNumber: 82,
  phoneNumber: "",
  email: "",
  plan: "",
  agreedToTerms: false,
};

export const useApplyForm = () => {
  const { mutate: paymentMutation, isPending: isPaymentPending } = useApplyMembershipPayment();

  const form = useForm({
    defaultValues: DEFAULT_VALUES,
    onSubmit: async ({ value }) => {
      if (isPaymentPending) return;

      const [planType, planUnit] = value.plan.split("-");

      paymentMutation({
        company: {
          title: value.companyName,
          representative_first_name: value.firstName,
          representative_last_name: value.lastName,
          phone_number: value.phoneNumber,
          phone_number_country_code: value.countryNumber,
          email: value.email,
        },
        membership: {
          type: planType,
          billing_cycle: planUnit,
        },
      });
    },
  });

  return { form, isPaymentPending };
};

export type ApplyFormInstance = ReturnType<typeof useApplyForm>["form"];

export const isApplyFormValid = (
  values: Pick<
    ApplyFormValues,
    "companyName" | "firstName" | "lastName" | "phoneNumber" | "email" | "plan" | "agreedToTerms"
  >,
): boolean =>
  values.companyName.trim() !== "" &&
  values.firstName.trim() !== "" &&
  values.lastName.trim() !== "" &&
  values.phoneNumber.trim() !== "" &&
  values.email.trim() !== "" &&
  values.plan !== "" &&
  values.agreedToTerms;
